
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-I-prelims-exam-answer-key",
      function () {
        return require("private-next-pages/tnpsc-group-I-prelims-exam-answer-key/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-I-prelims-exam-answer-key"])
      });
    }
  